export default __webpack_public_path__ + "static/media/Snd_b5.417db5af.mp3";